import { render, staticRenderFns } from "./IngredientMeasureUnits.vue?vue&type=template&id=1b6d4cc9&"
import script from "./IngredientMeasureUnits.vue?vue&type=script&lang=js&"
export * from "./IngredientMeasureUnits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports